import { isInternalUrl } from '@marketplace-web/browser/url-util'

import { ROOT_URL } from '../constants/routes'

export const getRefUrlContextless = () => {
  const currentUrl = new URL(document.location.href)
  const refUrl = decodeURIComponent(currentUrl.searchParams.get('ref_url') || '')

  if (!refUrl || !isInternalUrl(refUrl)) return ROOT_URL

  return refUrl
}
